// Поліфіл closest для старих браузерів (IE11)
if (!Element.prototype.closest) {
  Element.prototype.closest = function(selector) {
    let el = this
    while (el) {
      if (el.matches(selector)) return el
      el = el.parentElement
    }
    return null
  }
}

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import VuePhoneNumberInput from "vue-phone-number-input";
import Vue2Editor, { Quill } from "vue2-editor";
import VueSweetalert2 from "vue-sweetalert2";
import "./styles-connect.scss";
import "sweetalert2/dist/sweetalert2.min.css";

import Store from "./store";
import Echo from "laravel-echo";
import SocketClient from "socket.io-client";

import vueDebounce from "vue-debounce";
import { syncSharedAuth, rememberPendingFavorite, applyPendingFavorite, applyGuestFavorites } from "@/utils/sharedAuth";

Vue.use(vueDebounce);

router.afterEach(() => {
  if (store.getters["user/getAuthToken"] && !window.io && !window.Echo) {
    window.io = SocketClient;
    window.Echo = new Echo({
      transports: ["websocket", "polling", "flashsocket"],
      broadcaster: "socket.io",
      host: process.env.VUE_APP_API + ":6001",
      authEndpoint: "/broadcasting/auth",
      auth: {
        headers: {
          Authorization: "Bearer " + Store.getters["user/getAuthToken"],
        },
      },
      // path: "/ws/socket.io",
    });
  }
});

Vue.use(VueSweetalert2);
Vue.component("vue-phone-number-input", VuePhoneNumberInput);
Vue.use(vuetify);
Vue.use(Vue2Editor);
//the page scrolls, not the editor: Quill keeps its scroll position when a dropdown (heading, colour, alignment) returns the focus,
//otherwise focusing the editor jumped the page to the start of the article
Quill.DEFAULTS.scrollingContainer = "html";

Vue.config.productionTip = process.env.NODE_ENV !== "production";
Vue.prototype.$eventHub = new Vue();

store.dispatch("settings/load");

// hearts on the public site: a signed-in client's token is shared with it, a guest's heart is finished after sign-in
rememberPendingFavorite(window.location.search);
syncSharedAuth(store.state);
applyPendingFavorite(store.state);
applyGuestFavorites(store.state);
store.subscribe((mutation, state) => {
  syncSharedAuth(state);
  applyPendingFavorite(state);
  applyGuestFavorites(state);
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
